
import { Tabs } from "@shared/ui/tabs";
import { Button } from "@shared/ui/button";
import { 
  Plus,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { CurrentList } from "../currentList/currentList";
import { HistoryList } from "../historyList/historyList";
import { Summary } from "../summary";

const DisconnectionLandingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="page-title">Disconnection Management</h1>
          <p className="page-subtitle">View, filter and manage disconnections.</p>
        </div>
        <div className="flex gap-2">
        <Button onClick={() => navigate("/cx/disconnections/create")}>
            <Plus className="mr-2 h-4 w-4" />
            Create Disconnection
          </Button>
        </div>
      </div>

      <Summary />

      <div className="flex flex-col space-y-4">
        <div className="w-full overflow-hidden">
        <Tabs 
        defaultValue="current"
        className="w-full"
        tabsListClassName="grid w-full grid-cols-2 mb-6"
        urlMapping={{
          current: "current",
          history: "history",
        }}
        tabComponents={{
          current: {
            label: "Current",
            component: <CurrentList />
          },
          history: {
            label: "History",
            component: <HistoryList />
          }
        }}
      />
        </div>
      </div>
    </div>
  );
};

export default DisconnectionLandingPage;
